import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseDesc, BaseTitle, BaseContainer, BaseImage,
} from './styles';

const vPadding = 200;
const Container = styled(BaseContainer)`
  margin-top: ${vPadding + 8}px;
  ${props => (!props.theme.isMobile && `
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

export default function WrapUpEmails() {
  const { wrapUp, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#wrapup', vPadding);

  return (
    <Container id="wrapup">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Features</SectionName>
        <BaseTitle>Wrap Up Emails: Unclutter your inbox</BaseTitle>
        <BaseDesc>
          Wrap Up emails consolidate a full days, weeks or months worth of your followed
          contributors wires into a single beautifully organised email, ensuring you&apos;ll never
          miss their valuable insights. You also have full control on how frequently you receive
          your notifications; immediately, daily, weekly or monthly, it&apos;s up to you.
        </BaseDesc>
      </Plx>
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <BaseImage src={wrapUp} />
      </Plx>
    </Container>
  );
}
